import PageContainer from 'components/Page/PageContainer'
import PageData from 'components/Page/PageData'
import PagePresentation from 'components/Page/PagePresentation'

export default {
  Container: PageContainer,
  Data: PageData,
  Presentation: PagePresentation,
}
